export default __webpack_public_path__ + "static/media/arrow-lg-icon.32ab1330.png";